/**
 * @generated SignedSource<<3ed644749eca69c7e3089b14166f51ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type booksPage_Query$variables = {
  from?: string | null | undefined;
};
export type booksPage_Query$data = {
  readonly books: {
    readonly balanceSheet: {
      readonly asOf: string;
      readonly assets: ReadonlyArray<{
        readonly balance: number;
        readonly code: string;
        readonly name: string;
      }>;
      readonly balances: boolean;
      readonly equity: ReadonlyArray<{
        readonly balance: number;
        readonly code: string;
        readonly name: string;
      }>;
      readonly liabilities: ReadonlyArray<{
        readonly balance: number;
        readonly code: string;
        readonly name: string;
      }>;
      readonly totalAssets: number;
      readonly totalEquity: number;
      readonly totalLiabilities: number;
    };
    readonly health: {
      readonly balanced: boolean;
      readonly equationHolds: boolean;
      readonly suspense: number;
      readonly transferClearing: number;
      readonly walletClearing: number;
    };
    readonly incomeStatement: {
      readonly expenses: ReadonlyArray<{
        readonly amount: number;
        readonly line: string;
      }>;
      readonly netIncome: number;
      readonly revenue: number;
      readonly totalExpense: number;
    };
    readonly trialBalance: ReadonlyArray<{
      readonly balance: number;
      readonly code: string;
      readonly kind: string | null | undefined;
      readonly name: string;
    }>;
  };
};
export type booksPage_Query = {
  response: booksPage_Query$data;
  variables: booksPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "from"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "from",
    "variableName": "from"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "asOf",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balances",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalAssets",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalLiabilities",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalEquity",
  "storageKey": null
},
v11 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v5/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenue",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalExpense",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "netIncome",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "line",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balanced",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "equationHolds",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suspense",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transferClearing",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "walletClearing",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v23 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v5/*: any*/),
  (v22/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "booksPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Books",
        "kind": "LinkedField",
        "name": "books",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LedgerAccountBalance",
            "kind": "LinkedField",
            "name": "trialBalance",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BooksBalanceSheet",
            "kind": "LinkedField",
            "name": "balanceSheet",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LedgerAccountBalance",
                "kind": "LinkedField",
                "name": "assets",
                "plural": true,
                "selections": (v11/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LedgerAccountBalance",
                "kind": "LinkedField",
                "name": "liabilities",
                "plural": true,
                "selections": (v11/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LedgerAccountBalance",
                "kind": "LinkedField",
                "name": "equity",
                "plural": true,
                "selections": (v11/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BooksIncomeStatement",
            "kind": "LinkedField",
            "name": "incomeStatement",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BooksExpenseLine",
                "kind": "LinkedField",
                "name": "expenses",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BooksHealth",
            "kind": "LinkedField",
            "name": "health",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "booksPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Books",
        "kind": "LinkedField",
        "name": "books",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LedgerAccountBalance",
            "kind": "LinkedField",
            "name": "trialBalance",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v22/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BooksBalanceSheet",
            "kind": "LinkedField",
            "name": "balanceSheet",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LedgerAccountBalance",
                "kind": "LinkedField",
                "name": "assets",
                "plural": true,
                "selections": (v23/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LedgerAccountBalance",
                "kind": "LinkedField",
                "name": "liabilities",
                "plural": true,
                "selections": (v23/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LedgerAccountBalance",
                "kind": "LinkedField",
                "name": "equity",
                "plural": true,
                "selections": (v23/*: any*/),
                "storageKey": null
              },
              (v22/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BooksIncomeStatement",
            "kind": "LinkedField",
            "name": "incomeStatement",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BooksExpenseLine",
                "kind": "LinkedField",
                "name": "expenses",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v22/*: any*/)
                ],
                "storageKey": null
              },
              (v22/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BooksHealth",
            "kind": "LinkedField",
            "name": "health",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/)
            ],
            "storageKey": null
          },
          (v22/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2804ad04c58af16ba35f5ea1fc3997ce",
    "id": null,
    "metadata": {},
    "name": "booksPage_Query",
    "operationKind": "query",
    "text": "query booksPage_Query(\n  $from: String\n) {\n  books(from: $from) {\n    trialBalance {\n      code\n      name\n      kind\n      balance\n      id\n    }\n    balanceSheet {\n      asOf\n      balances\n      totalAssets\n      totalLiabilities\n      totalEquity\n      assets {\n        code\n        name\n        balance\n        id\n      }\n      liabilities {\n        code\n        name\n        balance\n        id\n      }\n      equity {\n        code\n        name\n        balance\n        id\n      }\n      id\n    }\n    incomeStatement {\n      revenue\n      totalExpense\n      netIncome\n      expenses {\n        line\n        amount\n        id\n      }\n      id\n    }\n    health {\n      balanced\n      equationHolds\n      suspense\n      transferClearing\n      walletClearing\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5ab75c140f7e04a5d4eba8c9a3744d09";

export default node;
